import { render, staticRenderFns } from "./MarriageVisa.vue?vue&type=template&id=4ab5d60c&"
import script from "./MarriageVisa.vue?vue&type=script&lang=js&"
export * from "./MarriageVisa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports